import { c as _c } from "react/compiler-runtime";
/* eslint-disable react/no-multi-comp */
import { Skeleton } from '@svenskaspelab/ui/react/skeleton';
import type { ReactNode } from 'react';

/**
 * Fallback component for a single coupon event, displayed while the event data is being fetched or if there is an error fetching the data.
 *
 * @returns A skeleton loading state mimicking the layout of a single coupon event.
 */
export function CouponEventFallback() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Skeleton className="h-5 w-5 rounded [grid-area:badge]" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex flex-col gap-1 [grid-area:description]"><Skeleton className="h-5 w-30 rounded lg:w-50" /><Skeleton className="h-5 w-30 rounded lg:w-50" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="bg-surface-elevated grid h-19 w-full grid-cols-[fit-content(100%)_minmax(100px,1fr)_130px] gap-3 rounded-md p-4 [grid-template-areas:'badge_description_outcomes'] lg:grid-cols-[fit-content(100%)_minmax(180px,1fr)_200px]">{t0}{t1}<div className="flex h-10 w-full gap-3 rounded [grid-area:outcomes]"><Skeleton className="h-10 w-10 lg:w-18" /><Skeleton className="h-10 w-10 lg:w-18" /><Skeleton className="h-10 w-10 lg:w-18" /></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}

/**
 * Fallback component for the Coupon page, displayed while the coupon data is being fetched or if there is an error fetching the data.
 *
 * @returns A skeleton loading state mimicking the layout of the Coupon page.
 */
export default function CouponFallback() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="grid h-full w-full gap-2">{Array.from({
        length: 8
      }).map(_temp)}</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp(_, index) {
  return <CouponEventFallback key={index} />;
}